// extracted by mini-css-extract-plugin
export default {"root":"InterestsForm_root__k39mX"};